import { Icon, StatColumn, StatProps, useTextColorMap } from "@bridgesplit/ui";
import { formatLeverage } from "@bridgesplit/abf-react";

import { CaptionWithIcon } from "../common";

export function RewardsMaxLeverage({ maxLeverage }: { maxLeverage: number | undefined }) {
    const textColorMap = useTextColorMap();
    const stats: StatProps[] = [
        {
            value: formatLeverage(maxLeverage),
            caption: (
                <CaptionWithIcon
                    caption="Max Leverage"
                    iconColor={textColorMap("caption")}
                    icon={<Icon type="leverage" />}
                    variant="body2"
                />
            ),
            variant: "body2"
        }
    ];
    return <StatColumn stats={stats} captionVariant="body1" loading={!maxLeverage} />;
}
